import styled from "styled-components";

export const SuperInteractionStyle = styled.div`
        display: inline-flex;
        flex-wrap: wrap;
        gap:${props => props.theme.space.paddingXS}px;
`